<template lang="pug">
div
    .alert.alert-warning(v-if="err") {{err.message}}
    .alert.alert-success(v-if="successMessage") {{successMessage}}
    .card
        .card-header
            h5.mb-0 Biobank Access
        .card-body
            p.text-muted Select a biobank and open the regular biobank editor view with that context.
            .mb-2
                strong Current biobank:
                span.ml-2 {{currentBiobank || "not set"}}
            .list-group
                button.list-group-item.list-group-item-action(
                    v-for="biobank in biobanks",
                    :key="biobank.id",
                    @click="openBiobank(biobank.id)"
                ) {{biobank.id}} - {{biobank.name}}
</template>

<script>
import {getAdminBiobanks, setActiveBiobank} from "../../api";

export default {
    data() {
        const localBiobank = localStorage.getItem("biobank");
        return {
            err: null,
            successMessage: "",
            biobanks: [],
            currentBiobank: (localBiobank && localBiobank !== "null" && localBiobank !== "undefined") ? localBiobank : ""
        };
    },
    created() {
        getAdminBiobanks()
            .then(biobanks => {
                this.err = null;
                this.biobanks = biobanks;
            })
            .catch(err => this.err = err);
    },
    methods: {
        openBiobank(biobankId) {
            setActiveBiobank(biobankId)
                .then((sessionInfo) => {
                    localStorage.setItem("biobank", sessionInfo.biobank);
                    localStorage.setItem("allowed_domains", JSON.stringify(sessionInfo.allowed_domains || []));
                    this.currentBiobank = sessionInfo.biobank;
                    this.successMessage = `Active biobank changed to ${sessionInfo.biobank}`;
                    this.$router.push("/biobank");
                })
                .catch(err => this.err = err);
        }
    }
};
</script>
